// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert-module--alert--2BrPc","hasTitle":"Alert-module--hasTitle--KvJCj"};